import Icon from '../components/Icon.vue'

Icon.register({"skull":{"width":512,"height":512,"paths":[{"d":"M256 0C114.6 0 0 100.3 0 224 0 294.1 36.9 356.6 94.5 397.7 104.1 404.6 109.7 415.8 108 427.6L98.6 493.8C97.2 503.4 104.6 512 114.3 512H192V456C192 451.6 195.6 448 200 448H216C220.4 448 224 451.6 224 456V512H288V456C288 451.6 291.6 448 296 448H312C316.4 448 320 451.6 320 456V512H397.7C407.4 512 414.8 503.4 413.4 493.8L404 427.6C402.3 415.9 407.8 404.6 417.5 397.7 475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zM160 320C124.7 320 96 291.3 96 256S124.7 192 160 192 224 220.7 224 256 195.3 320 160 320zM352 320C316.7 320 288 291.3 288 256S316.7 192 352 192 416 220.7 416 256 387.3 320 352 320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/skull.js
// module id = WVg5
// module chunks = 0